import {getSettlementHistory} from '@web/actions/saleSettlement'
import makeSlice from '@web/slices/pagination/sliceMaker'

const paginationSlice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(getSettlementHistory.fulfilled, (state, {payload}) => {
            const {pagination} = payload
            state.current = pagination.page ?? 1
            state.start = 1
            state.end = pagination.totalPages ?? 1
            state.total = pagination.totalPages ?? 1
        })
    },
})

export default paginationSlice.reducer
